module.exports = __webpack_public_path__ + "fonts/nexa-bold-webfont.6aecd77f.otf";